import { Suspense, ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps, Switch } from 'react-router-dom';

import { fomatParentPath, isMobile } from '../../utils';
import { Loading, Login, MLogin } from '../../lib';

function Coms(props: any) {
    return (
        <>
            <Suspense weId={`${props.weId || ''}_6d6ath`} fallback={<Loading weId={`${props.weId || ''}_v5j38t`} />}>
                {isMobile() ? <MLogin weId={`${props.weId || ''}_8l4j6t`} /> : <Login weId={`${props.weId || ''}_pylpnk`} />}
            </Suspense>
        </>
    )
}
function RouteLogin(props: RouteComponentProps & ComponentProps<any>) {
    const parentPath: string = fomatParentPath(props);
    return (
        <Switch weId={`${props.weId || ''}_td9zv9`}>
            <Route weId={`${props.weId || ''}_6p6nql`} path={`${parentPath}/login`} component={Coms} />
            <Route weId={`${props.weId || ''}_6p6nql`} path={`${parentPath}/customlogin/:customPath`} component={Coms} />
            {/* <Route weId={`${props.weId || ''}_712j6g`} path={`${parentPath}/`} component={Coms} /> */}
        </Switch>
    )
}
export default withRouter(RouteLogin);
